<script>
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import PostFeed from '@router/components/post-feed.vue'

export default {
  components: {
    Layout,
    PostFeed,
  },
  props: {
    routeFrom: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      loadingMore: false,
      noMorePosts: false,
    }
  },
  computed: {
    ...authComputed,
    singleStatusUpdateArray() {
      return [this.$store.state.posts.statusUpdate] || []
    },
  },
  mounted() {},
  methods: {
    fetchMoreStatusUpdates() {
      this.noMorePosts = true
      return false
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white pt-4 px-8 pb-4">
      <div class="text-black text-xl">
        Your Activity
      </div>
    </div>
    <div class="flex h-auto pt-6 pr-20 pl-15 bg-blue-lightest">
      <div
        class="left-posts w-7/12 max-w-1.95xl bg-white rounded-xl mr-17 shadow-box overflow-hidden"
      >
        <PostFeed
          :status-updates="singleStatusUpdateArray"
          :loading-more="loadingMore"
          :no-more-posts="noMorePosts"
          show-comment-section
          @fetch-more-status-updates="fetchMoreStatusUpdates"
        ></PostFeed>
      </div>
    </div>
  </Layout>
</template>
